export enum ScheduleSummaryTab {
  AVAILABILITIES = 'AVAILABILITIES',
  TRIPS = 'TRIPS',
}
